<script lang="ts">
    import { trans } from '$assets/shop-translator.js';
    import cn from '$common/utils/cn';
    import FilterBadges from '$saga/views/Search/components/filterBadges/FilterBadges.svelte';
    import {
        arePillarFiltersActive,
        areSecondaryFiltersActive,
        filtersContext,
    } from '$saga/views/Search/store';
</script>

<div
    class={cn(
        'h-fit w-full max-w-[300px] border border-b-0 border-solid border-border-quiet rounded-t-m bg-white px-s',
        $filtersContext.hideVerticalBar && 'hidden',
    )}
>
    <div class="flex flex-col gap-m py-m">
        <span class="font-semibold">{trans('search.filter.sidebar.title')}</span
        >
        {#if $arePillarFiltersActive || $areSecondaryFiltersActive}
            <FilterBadges />
        {/if}
    </div>
</div>
